/* eslint-disable import/no-anonymous-default-export */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ParticipantStream } from '../core/reducers';
import { hiddenFullScreenStyle, fullScreenStyle, loadingStyle, fullScreenDarkStyle, pivotItemStyle } from './styles/MediaFullScreen.styles';
import { RemoteVideoStream, VideoStreamRenderer, VideoStreamRendererView } from '@azure/communication-calling';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { ChatIcon } from '@fluentui/react-icons-northstar';
import { utils, IsCentralScreenMode, IsHiddenUser } from 'Utils/Utils';
import { messagesCount, messageSender ,isTeamsChatHasHistory} from '../core/sideEffects';

export interface MediaFullScreenProps {
  activeScreenShareStream: ParticipantStream;
}

export default (props: MediaFullScreenProps): JSX.Element => {
  const [loading, setLoading] = useState(true);
  const fullScreenStreamMediaId = 'fullScreenStreamMediaId';
  const fullScreenMediaIdContainerDiv = "fullScreenMediaIdContainerDiv";
  const rendererViewRef = useRef<VideoStreamRendererView>();

  /**
   * Start stream after DOM has rendered
   */

  const activeScreenShareStream = props.activeScreenShareStream;
  const isHorizontal = window.innerWidth >= (2 * window.innerHeight);

  const renderStreamCallback = useCallback(async () => {
      if (activeScreenShareStream && activeScreenShareStream.stream) {
      const stream: RemoteVideoStream = activeScreenShareStream.stream;
      const renderer: VideoStreamRenderer = new VideoStreamRenderer(stream);
      rendererViewRef.current = await renderer.createView({ scalingMode: 'Fit' });

      var videoList = rendererViewRef.current.target.getElementsByTagName("video");
      for (let i = 0; i < videoList.length; i++) {
          videoList[i].setAttribute("style", "width: 100%; height: 100%; position: absolute;");
          videoList[i].attributes.setNamedItem(document.createAttribute("disablePictureInPicture"));
          }

      const container = document.getElementById(fullScreenStreamMediaId);
      if (container && container.childElementCount === 0) {
        setLoading(false);
        container.appendChild(rendererViewRef.current.target);
      }
      if (container && container.childElementCount > 0) {
          var videoContainer = container.children[0];
          if (IsCentralScreenMode()) {
              if (isHorizontal) {
                  videoContainer.setAttribute("style", "height: 100%; width:100%;");
              }
              else {
                  videoContainer.setAttribute("style", "height: auto; width:100%;");
              }
          }
      }
    } else {
      if (rendererViewRef) {
        rendererViewRef.current?.dispose();
      }
    }
  }, [activeScreenShareStream, IsCentralScreenMode, isHorizontal]);

  useEffect(() => { 
          renderStreamCallback();
  }, [renderStreamCallback]);

  const displayName =
    props.activeScreenShareStream.user.displayName ?? utils.getId(props.activeScreenShareStream.user.identifier);

  return (
    <>
      {loading && (
        <div className={loadingStyle}>
          <Spinner label={`Loading ${displayName}'s screen`} size={SpinnerSize.xSmall} />
        </div>
          )}
          <div id={fullScreenMediaIdContainerDiv}
              style={{
                  display: 'block',
                  alignItems: 'start',
                  position: 'relative'
              }}
              className={loading ? hiddenFullScreenStyle : IsCentralScreenMode() ? fullScreenDarkStyle : fullScreenStyle}>
              {!loading && IsCentralScreenMode() && (messagesCount > 0 || isTeamsChatHasHistory ) && !IsHiddenUser(messageSender) && (
                  <div >
                      <ChatIcon size="largest" outline={false} className={pivotItemStyle} />
                </div>
            )}
              <div id={fullScreenStreamMediaId} style={{
                  maxHeight: '100%',
                  maxWidth: '100%',
                  display: 'block',
              }}>
            </div>
          </div>
    </>
  );
};
